export enum CompanyTabs {
  company = 'company',
}
export interface ITabState {
  defaultValues: any;
}
export const tabStateModel: ITabState = {
  defaultValues: {},
};
